import PropTypes from 'prop-types';
import React from 'react';

import { TopCommentIcon } from '../icons';
import withTopCommentColor from '../../hoc/with-top-comment-color';
import styles from './top-comment.scss';

const TopCommentMobile = ({ topCommentColor }) => (
  <div className={styles.topComment}>
    <TopCommentIcon className="button-fill" color={topCommentColor}/>
  </div>
);

TopCommentMobile.propTypes = {
  topCommentColor: PropTypes.string,
  t: PropTypes.func,
};

export default withTopCommentColor(TopCommentMobile);



// WEBPACK FOOTER //
// ./app/components/top-comment/top-comment-mobile.js